import { type TFunction } from 'i18next'
import {
  AuthorizeErrorCodes,
  type IAuthorizeErrors,
  type IAuthorizePaymentResponse,
} from '../index.h'

const errorMessages = {
  // Input errors
  [AuthorizeErrorCodes.E_WC_05]: 'card_number_error',
  [AuthorizeErrorCodes.E_WC_06]: 'expiry_date_error',
  [AuthorizeErrorCodes.E_WC_07]: 'expiry_date_error',
  [AuthorizeErrorCodes.E_WC_08]: 'expiry_date_error',
  [AuthorizeErrorCodes.E_WC_15]: 'security_code_error',
  // Common errors
  [AuthorizeErrorCodes.E_WC_01]: 'include_library_from_cdn',
  [AuthorizeErrorCodes.E_WC_02]: 'https_connection_required',
  [AuthorizeErrorCodes.E_WC_03]: 'library_not_loaded_correctly',
  [AuthorizeErrorCodes.E_WC_04]: 'library_provide_mandatory_field',
  [AuthorizeErrorCodes.E_WC_10]: 'library_provide_valid_apiloginid',
  [AuthorizeErrorCodes.E_WC_13]: 'invalid_fingerprint',
  [AuthorizeErrorCodes.E_WC_14]: 'library_encryption_failed',
  [AuthorizeErrorCodes.E_WC_16]: 'provide_valid_zip',
  [AuthorizeErrorCodes.E_WC_17]: 'provide_valid_cardholder_name',
  [AuthorizeErrorCodes.E_WC_18]: 'client_key_required',
  [AuthorizeErrorCodes.E_WC_19]: 'error_occured_during_processing',
  [AuthorizeErrorCodes.E_WC_21]: 'invalid_autentication_values',
  [AuthorizeErrorCodes.E_WC_23]: 'provide_card_or_bank_info',
}

export const parseErrors = (
  ...args: [{ t: TFunction }, Omit<IAuthorizePaymentResponse, 'opaqueData'>]
): IAuthorizeErrors => {
  const [{ t }, { messages }] = args

  const commonError = t('unknown_error')
  if (!messages) {
    return {
      commonError,
    }
  }

  const errors: IAuthorizeErrors = {}
  for (const error of messages.message) {
    switch (error.code) {
      case AuthorizeErrorCodes.E_WC_05:
        errors.cardNumber = t(errorMessages[error.code])
        break
      case AuthorizeErrorCodes.E_WC_06:
      case AuthorizeErrorCodes.E_WC_07:
      case AuthorizeErrorCodes.E_WC_08: {
        errors.expirationDate = t(errorMessages[error.code])
        break
      }
      case AuthorizeErrorCodes.E_WC_15: {
        errors.cvv = t(errorMessages[error.code])
        break
      }
      case AuthorizeErrorCodes.E_WC_01:
      case AuthorizeErrorCodes.E_WC_02:
      case AuthorizeErrorCodes.E_WC_03:
      case AuthorizeErrorCodes.E_WC_04:
      case AuthorizeErrorCodes.E_WC_10:
      case AuthorizeErrorCodes.E_WC_13:
      case AuthorizeErrorCodes.E_WC_14:
      case AuthorizeErrorCodes.E_WC_16:
      case AuthorizeErrorCodes.E_WC_17:
      case AuthorizeErrorCodes.E_WC_18:
      case AuthorizeErrorCodes.E_WC_19:
      case AuthorizeErrorCodes.E_WC_21:
      case AuthorizeErrorCodes.E_WC_23: {
        errors.commonError = t(errorMessages[error.code])
        break
      }
    }
  }

  return errors
}
